import Vue from 'vue/dist/vue.common';
import { apolloProvider } from "../vue-apollo-init";
import gql from 'graphql-tag'
import _ from 'lodash';
import postQuery from './../gql/post_query.graphql';

export class Page_Content {
    constructor(){
        this.vue_element = false;        
    }
    init(){
        let store = window.store;
        let router = window.router;

        this.vue_element = new Vue({
          apolloProvider,
          apollo: {
            article_item: {
              query: postQuery,
              update (data) {
                if(data.post){
                  return {...data.post, 'element_id': 'main-right' };
                } else {
                  return {...data.page, 'element_id': 'main-right' };
                }
              },
              variables() {
                return {
                  //post_id: store.state.post_id
                  post_uri: store.state.post_uri
                }
              },
            }
          },
          el: '#main-right',
          template: '#page-template',
          data: store.state,
          updated: function () {
            this.$nextTick(function () {
              router.updatePageLinks();
              const mainRightSlider = document.getElementById('main-right-slider');
              if(mainRightSlider){
                mainRightSlider.classList.remove('animated-css');
                window.setTimeout(function(){
                  mainRightSlider.classList.remove('active');
                  window.setTimeout(function(){
                    mainRightSlider.classList.add('animated-css');
                  }, 100);
                }, 100);
              }
            })
          },
          methods: {
            open_menu: function (event) {
              document.getElementById('menu__wrapper').classList.add('active');
              document.getElementById('main-right-container').classList.remove('hide');
            },
            scroll_to_top: function (event) {
              window.scrollTo(0,0);
              document.getElementById('main-right-container').scrollTo({
                top: 0,
                behavior: 'smooth'
              });
            },
            set_tag(tag_id, tag_title) {
              store.setTag({tag_id: tag_id, tag_title: tag_title});
            },
            is_tag_active(tag_id, tag_title) {
              if(this?.posts_tags?.tag_id){
                return tag_id == this.posts_tags.tag_id;
              } else {
                return false;
              }
            },
            set_cat(cat_id, cat_type){
              store.setCat(cat_id, cat_type);
            },
            is_cat_active(cat_id, cat_type) {
              return _.some(this.posts_cats, {taxonomy: cat_type, terms: cat_id})
            }
          },
          computed: {
            orderedPages: function () {
              return _.orderBy(this?.article_item?.children?.nodes, 'menuOrder')
            },
            orderedParentPages: function () {
              return _.orderBy(this?.article_item?.parent?.node?.children?.nodes, 'menuOrder')
            }
          }
        });
    }
}